export default function requestAnimationFrameExact(callback: any) {
  let time = +new Date();
  (function loop() {
    window.requestAnimationFrame(() => {
      if (+new Date() - time < 16.7) {
        loop();
      } else {
        callback();
      }
    });
  })();
}
